module.exports = __webpack_public_path__ + "static/media/broadcast.7834f9cc.svg";